<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { useTasksStore } from '@/stores/v2';
import { storeToRefs } from 'pinia';
import { useFishTransfer } from "@/composables/tasks/animal-transfer/useAnimalTransfer";
import { computed } from 'vue';

import TaskHeader from '@/components/v2/Tasks/Task/TaskHeader.vue';
import OperationCard from '@/components/v2/Tasks/AnimalTransfer/Cards/OperationCard/OperationCard.vue';
import StatusCard from '@/components/v2/Tasks/AnimalTransfer/Cards/StatusCard/StatusCard.vue';
import TransferList from '@/components/v2/Tasks/AnimalTransfer/Lists/TransferList.vue';
import TransferInput from '@/components/v2/Tasks/AnimalTransfer/Forms/TransferInput.vue';
import FooterActions from '@/components/v2/Tasks/Vaccination/Buttons/ActionButtons/FooterActions.vue';
import FishTransferLogModal from '@/components/v2/Tasks/AnimalTransfer/Modals/TransferLogModal.vue';
import InstructionsModal from '@/components/v2/Tasks/AnimalTransfer/Modals/InstructionsModal.vue';

const { activeTask } = storeToRefs(useTasksStore())

const {
    newTags,
    transferInfo,
    transferBalance,
    actualTransfers,
    globalTransferAmount,
    fishTransferLogModal,
    instructionsModal,
    performOperation,
    handleCompleteTask,
    toggleInstructionsModal,
    toggleFishTransferLogModal,
} = useFishTransfer();

const isCompleteDisabled = computed(() => transferBalance.value < 1);
</script>

<template>
    <div>
        <TaskHeader v-if="activeTask" :title="activeTask.title" :study="activeTask.studyTitle" />

        <div class="mt-8">
            <!-- Operation and Status Cards -->
            <div class="flex justify-between gap-4">
                <OperationCard class="w-full" :transferInfo="transferInfo" :actualTransfers="actualTransfers"
                    :new-tags="newTags" />
                <StatusCard class="w-full" :transferInfo="transferInfo" :transferBalance="transferBalance" />
            </div>

            <span class="my-4 h-[1px] border-b border-gray-200 block" />

            <!-- Transfer List -->
            <TransferList :transfers="actualTransfers" :transferInfo="transferInfo" />

            <!-- Transfer Input -->
            <TransferInput v-model="globalTransferAmount" :transferInfo="transferInfo"
                :performOperation="performOperation" />
        </div>

        <!-- Footer Actions -->
        <FooterActions>
            <template #start>
                <button
                    @click="toggleInstructionsModal"
                    class="w-full"
                >
                    Instructions
                </button>
            </template>
            <template #end>
                <button
                    @click="handleCompleteTask"
                    class="w-full disabled:opacity-50 disabled:cursor-not-allowed"
                    :disabled="isCompleteDisabled"
                >
                    Complete task
                </button>
            </template>
        </FooterActions>

        <!-- Modals -->
        <InstructionsModal :showModal="instructionsModal" @close="toggleInstructionsModal" />

        <FishTransferLogModal :showModal="fishTransferLogModal"
            :toggleFishTransferLogModal="toggleFishTransferLogModal" :amount="transferBalance" />
    </div>
</template>